<template>
  <div class="card-on-card card-outline-secondary">
    <div class="card-header">
      <h5 class="mb-2 font-weight-bold">Informasi Harga</h5>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <!-- Pph pertama -->
          <div class="form-row mb-4 mb-4">
            <!-- Input Harga -->
            <div class="col-md-6">
              <div class="form-group">
                <div class="form-group">
                  <label>Harga Satuan </label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label class="input-group-text">Rp.</label>
                    </div>
                    <input
                      v-model="nonBookUnitPrice"
                      inputmode="decimal"
                      minlength="2"
                      max="999999999999"
                      maxlength="20"
                      id="nonBookUnitPrice"
                      class="form-control"
                      placeholder="3000000"
                    />
                    <div
                      id="invalidHargaSatuan"
                      class="invalid-feedback invalidHargaSatuan"
                    >
                      Penyedia tidak bisa input harga satuan kurang dari 100!
                    </div>
                  </div>
                  <div>
                    <!-- ppn -->
                    <table v-if="isPpnDikenakan">
                      <tr style="display: table-row;">
                        <td width="20%"><small> DPP PPH </small></td>
                        <td width="2%">:</td>
                        <td>
                          <span id="dpp">{{ formatCurrency(dpp) }}</span>
                        </td>
                      </tr>
                      <tr style="display: table-row;">
                        <td width="20%"><small> DPP Nilai Lain </small></td>
                        <td width="2%">:</td>
                        <td>
                          <span id="dppNilaiLainHargaSatuan">{{
                            formatCurrency(dppNilaiLain)
                          }}</span>
                        </td>
                      </tr>
                      <tr style="display: table-row;">
                        <td><small> PPN 12%</small></td>
                        <td>:</td>
                        <td>
                          <span id="ppn">{{ formatCurrency(ppn) }}</span>
                        </td>
                      </tr>

                      <tr>
                        <td width="20%"><small> PPh 0.5%</small></td>
                        <td width="2%">:</td>
                        <td>
                          <span id="pph"> {{ formatCurrency(pph) }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td><small> *Dana diterima oleh penyedia</small></td>
                        <td>:</td>
                        <td>
                          <span id="terima">
                            {{ formatCurrency(danaDiterima) }}</span
                          >
                        </td>
                      </tr>
                    </table>

                    <!-- tidak ppn -->
                    <table v-if="!isPpnDikenakan">
                      <tr style="display: table-row;">
                        <td width="20%"><small> DPP PPH </small></td>
                        <td width="2%">:</td>
                        <td>
                          <span id="dppPph">{{
                            formatCurrency(this.nonBookUnitPrice)
                          }}</span>
                        </td>
                      </tr>
                      <tr style="display: table-row;">
                        <td width="20%"><small> DPP Nilai Lain </small></td>
                        <td width="2%">:</td>
                        <td>
                          <span id="dppNilaiLainHargaSatuan">{{
                            formatCurrency(0)
                          }}</span>
                        </td>
                      </tr>
                      <tr style="display: table-row;">
                        <td><small> PPN 12%</small></td>
                        <td>:</td>
                        <td>
                          {{ formatCurrency(0) }}
                        </td>
                      </tr>

                      <tr>
                        <td width="20%"><small> PPh 0.5%</small></td>
                        <td width="2%">:</td>
                        <td>
                          <span id="pph"> {{ formatCurrency(pphNoPpn) }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td><small> *Dana diterima oleh penyedia</small></td>
                        <td>:</td>
                        <td>
                          <span id="terima">
                            {{ formatCurrency(danaDiterimaNoPpn) }}</span
                          >
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- Nego -->
            <div class="col-md-6">
              <div class="form-group">
                <label class="text-success">Harga maks.nego</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <label class="input-group-text">Rp.</label>
                  </div>
                  <input
                    v-model="nonBookMaxNegoPrice"
                    inputmode="decimal"
                    minlength="2"
                    max="999999999999"
                    maxlength="20"
                    id="nonBookMaxNegoPrice"
                    class="form-control"
                  />
                  <div
                    id="invalidMaksNego"
                    class="invalid-feedback invalidMaksNego"
                  >
                    Penyedia tidak bisa input harga nego kurang dari 100!
                  </div>
                </div>
                <div>
                  <!-- ppn Nego -->
                  <table v-if="isPpnDikenakan">
                    <tr style="display: table-row;">
                      <td width="20%"><small> DPP PPH</small></td>
                      <td width="2%">:</td>
                      <td>
                        <span id="dppNego">{{ formatCurrency(dppNego) }}</span>
                      </td>
                    </tr>
                    <tr style="display: table-row;">
                      <td width="20%"><small> DPP Nilai Lain </small></td>
                      <td width="2%">:</td>
                      <td>
                        <span id="dppNilaiLainNego">{{
                          formatCurrency(dppNilaiLainNego)
                        }}</span>
                      </td>
                    </tr>
                    <tr style="display: table-row;">
                      <td><small> PPN 12%</small></td>
                      <td>:</td>
                      <td>
                        <span id="ppnNego">{{ formatCurrency(ppnNego) }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td width="20%"><small> PPh 0.5%</small></td>
                      <td width="2%">:</td>
                      <td>
                        <span id="pphNego">{{ formatCurrency(pphNego) }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td><small> Dana diterima oleh penyedia</small></td>
                      <td>:</td>
                      <td>
                        <span id="terimaNego">{{
                          formatCurrency(danaDiterimaNego)
                        }}</span>
                      </td>
                    </tr>
                  </table>

                  <!-- np ppn nego -->
                  <table v-if="!isPpnDikenakan">
                    <tr style="display: table-row;">
                      <td width="20%"><small> DPP PPH </small></td>
                      <td width="2%">:</td>
                      <td>
                        <span id="dpp">{{
                          formatCurrency(this.nonBookMaxNegoPrice)
                        }}</span>
                      </td>
                    </tr>
                    <tr style="display: table-row;">
                      <td width="20%"><small> DPP Nilai Lain </small></td>
                      <td width="2%">:</td>
                      <td>
                        <span id="dppNilaiLain">{{ formatCurrency(0) }}</span>
                      </td>
                    </tr>
                    <tr style="display: table-row;">
                      <td><small> PPN 12%</small></td>
                      <td>:</td>
                      <td>
                        {{ formatCurrency(0) }}
                      </td>
                    </tr>

                    <tr>
                      <td width="20%"><small> PPh 0.5%</small></td>
                      <td width="2%">:</td>
                      <td>
                        <span id="pph">
                          {{ formatCurrency(pphNegoNoPpn) }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td><small> *Dana diterima oleh penyedia</small></td>
                      <td>:</td>
                      <td>
                        <span id="terima">
                          {{ formatCurrency(danaDiterimaNoPpnNego) }}</span
                        >
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <small
              >*Perhitungan ini adalah simulasi. Besaran dana disalurkan dapat
              berkurang apabila terdapat pemotongan biaya administrasi layanan
              dari mitra</small
            >
            <small>
              *PPN yang dikenakan telah menggunakan perhitungan terbaru sesuai
              <a
                href="https://jdih.kemenkeu.go.id/api/download/ad276b82-94bd-4197-b409-af33e2842cd6/2024pmkeuangan131.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                PMK No. 131 Tahun 2024
              </a>
            </small>
          </div>
          <div class="form-row mb-4 mb-4">
            <div class="col-md-6">
              <div class="form-group">
                <label>Satuan Barang</label>
                <select
                  name="nonBookItemUnit"
                  id="nonBookItemUnit"
                  class="form-control"
                >
                  <option
                    label="Centimeter"
                    class="form-control"
                    value="Centimeter"
                  >
                    Centimeter
                  </option>
                  <option label="Gram" value="Gram">Gram</option>
                  <option label="Inch" value="Inch">Inch</option>
                  <option label="Kilogram" value="Kilogram">Kilogram</option>
                  <option label="Kilometer" value="Kilometer">Kilometer</option>
                  <option label="Liter" value="Liter">Liter</option>
                  <option label="Milligram" value="Milligram">Milligram</option>
                  <option label="Milliliter" value="Milliliter">
                    Milliliter
                  </option>
                  <option label="Meter" value="Meter">Meter</option>
                  <option label="m³" value="Meter Kubik">m³</option>
                  <option label="Lusin" value="Lusin">Lusin</option>
                  <option label="Kodi" value="Kodi">Kodi</option>
                  <option label="Gross" value="Kodi">Gross</option>
                  <option label="Rim" value="Rim">Rim</option>
                  <option label="Box" value="Box">Box</option>
                  <option label="Pcs" value="Pcs">Pieces</option>
                  <option label="Roll" value="Roll">Roll</option>
                  <option label="Set" value="Set">Set</option>
                  <option label="Unit" value="Unit" selected="selected">
                    Unit
                  </option>
                </select>
              </div>
            </div>
            <!-- Tag PPn -->
            <div class="col-md-6">
              <label>Tag PPN</label
              ><select
                name="tagPpnNonbok"
                id="tagPpnNonbok"
                class="form-control"
                ><option value="0:Dikenakan PPN">Dikenakan PPN </option
                ><option
                  value="1:Makanan dan minuman yang disajikan di hotel, restoran, rumah makan, warung, dan sejenisnya, meliputi makanan dan minuman baik yang dikonsumsi di tempat maupun tidak, termasuk makanan dan minuman yang diserahkan oleh usaha jas"
                  >Makanan dan minuman yang disajikan di hotel, restoran, rumah
                  makan, warung, dan sejenisnya, meliputi makanan dan minuman
                  baik yang dikonsumsi di tempat maupun tidak, termasuk makanan
                  dan minuman yang diserahkan oleh usaha jas </option
                ><option value="2:Jasa keagamaan">Jasa keagamaan </option
                ><option
                  value="3:Jasa kesenian dan hiburan, meliputi semua jenis jasa yang dilakukan oleh pekerja seni dan hiburan yang merupakan objek pajak daerah"
                  >Jasa kesenian dan hiburan, meliputi semua jenis jasa yang
                  dilakukan oleh pekerja seni dan hiburan yang merupakan objek
                  pajak daerah </option
                ><option
                  value="4:Jasa perhotelan, meliputi jasa penyewaan kamar dan/atau jasa penyewaan ruangan di hotel yang merupakan objek pajak daerah"
                  >Jasa perhotelan, meliputi jasa penyewaan kamar dan/atau jasa
                  penyewaan ruangan di hotel yang merupakan objek pajak daerah </option
                ><option
                  value="5:Jasa yang disediakan oleh pemerintah dalam rangka menjalankan pemerintahan secara umum"
                  >Jasa yang disediakan oleh pemerintah dalam rangka menjalankan
                  pemerintahan secara umum </option
                ><option value="6:Jasa penyediaan tempat parkir"
                  >Jasa penyediaan tempat parkir </option
                ><option
                  value="7:Pengadaan vaksin dalam rangka program vaksinasi nasional"
                  >Pengadaan vaksin dalam rangka program vaksinasi nasional </option
                ><option
                  value="8:Buku pelajaran umum, kitab suci, dan buku pelajaran agama dengan harga yang relatif terjangkau masyarakat umum, kitab suci, dan buku pelajaran agama dengan harga yang relatif terjangkau masyarakat"
                  >Buku pelajaran umum, kitab suci, dan buku pelajaran agama
                  dengan harga yang relatif terjangkau masyarakat umum, kitab
                  suci, dan buku pelajaran agama dengan harga yang relatif
                  terjangkau masyarakat </option
                ><option
                  value="9:Barang kebutuhan pokok yang sangat dibutuhkan oleh rakyat banyak"
                  >Barang kebutuhan pokok yang sangat dibutuhkan oleh rakyat
                  banyak </option
                ><option value="10:Jasa keuangan">Jasa keuangan </option
                ><option value="11:Jasa asuransi">Jasa asuransi </option
                ><option value="12:Jasa pendidikan">Jasa pendidikan </option
                ><option
                  value="13:Jasa angkutan umum di darat dan di air serta jasa angkutan udara dalam negeri yang menjadi bagian tidak terpisahkan dari jasa angkutan luar negeri"
                  >Jasa angkutan umum di darat dan di air serta jasa angkutan
                  udara dalam negeri yang menjadi bagian tidak terpisahkan dari
                  jasa angkutan luar negeri </option
                ><option value="14:Jangat dan kulit mentah yang tidak disamak"
                  >Jangat dan kulit mentah yang tidak disamak </option
                ><option
                  value="15:Ternak yang kriteria dan/atau rinciannya diatur dengan Peraturan Menteri setelah mendapat pertimbangan dari menteri yang menyelenggarakan urusan pemerintahan di bidang pertanian"
                  >Ternak yang kriteria dan/atau rinciannya diatur dengan
                  Peraturan Menteri setelah mendapat pertimbangan dari menteri
                  yang menyelenggarakan urusan pemerintahan di bidang pertanian </option
                ><option
                  value="16:Bibit dan/atau benih dari barang pertanian, perkebunan, kehutanan, peternakan, atau perikanan"
                  >Bibit dan/atau benih dari barang pertanian, perkebunan,
                  kehutanan, peternakan, atau perikanan </option
                ><option
                  value="17:Pakan ternak tidak termasuk pakan hewan kesayangan"
                  >Pakan ternak tidak termasuk pakan hewan kesayangan </option
                ><option value="18:Pakan ikan">Pakan ikan </option
                ><option
                  value="19:Bahan pakan untuk pembuatan pakan ternak dan pakan ikan, tidak termasuk imbuhan pakan dan pelengkap pakan, yang kriteria dan/atau rincian bahan pakan diatur dengan Peraturan Menteri"
                  >Bahan pakan untuk pembuatan pakan ternak dan pakan ikan,
                  tidak termasuk imbuhan pakan dan pelengkap pakan, yang
                  kriteria dan/atau rincian bahan pakan diatur dengan Peraturan
                  Menteri </option
                ><option
                  value="20:Bahan baku kerajinan perak dalam bentuk perak butiran dan/ atau dalam bentuk perak batangan"
                  >Bahan baku kerajinan perak dalam bentuk perak butiran dan/
                  atau dalam bentuk perak batangan </option
                ><option
                  value="21:Listrik, termasuk biaya penyambungan listrik dan biaya beban listrik, kecuali untuk rumah dengan daya di atas 6.600 (enam ribu enam ratus) Voltase/Amper"
                  >Listrik, termasuk biaya penyambungan listrik dan biaya beban
                  listrik, kecuali untuk rumah dengan daya di atas 6.600 (enam
                  ribu enam ratus) Voltase/Amper </option
                ><option value="22:Liquified Natural Gas (LNG)"
                  >Liquified Natural Gas (LNG) </option
                ><option
                  value="23:Penyerahan jasa angkutan umum oleh orang pribadi yang dilakukan melalui Pihak Lain"
                  >Penyerahan jasa angkutan umum oleh orang pribadi yang
                  dilakukan melalui Pihak Lain </option
                ><option
                  value="24:Penyerahan Barang Kena Pajak dan/atau Jasa Kena Pajak yang dilakukan oleh Rekanan yang pembayarannya dilakukan melalui mekanisme Pembayaran Langsung (LS)"
                  >Penyerahan Barang Kena Pajak dan/atau Jasa Kena Pajak yang
                  dilakukan oleh Rekanan yang pembayarannya dilakukan melalui
                  mekanisme Pembayaran Langsung (LS) </option
                ><option value="25:Pembayaran Honor/Narasumber"
                  >Pembayaran Honor/Narasumber </option
                ><option value="26:Pelatihan dan Biaya Perjalanan Dinas"
                  >Pelatihan dan Biaya Perjalanan Dinas
                </option></select
              >
              <div class="form-group"></div>
            </div>
          </div>
        </div>

        <!-- Paket Data -->
        <div class="card-body">
          <div class="card-header mb-3">
            <h5 class="mb-2">
              <b>Isi Paket</b>
            </h5>
            <p class="grosir-info">
              Isi paket berdasarkan produk yang sudah di input sebelumnya
            </p>

            <div class="col-md-12"></div>

            <div class="row">
              <div class="col-md-10">
                <input
                  type="text"
                  @change="$emit('input', $event.target.value)"
                  :value="findPaket"
                  class="form-control"
                  placeholder="Cari nama produk yang ada di toko anda"
                />
              </div>
              <div
                class="col-md-2"
                style="margin-top: -9px; margin-left: -32px"
              >
                <button class="btn btn-primary" type="button">Cari</button>
              </div>
              <div class="col-md-12">
                <table
                  class="table table-condensed text-center table-hover"
                  width="100%"
                >
                  <tbody>
                    <tr v-for="(dp, index) in dataPaket" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <img
                          :src="
                            'https://cdn.eurekabookhouse.co.id/ebh/product/all/' +
                              dp.image
                          "
                          class="img-responsive"
                          height="50px"
                          alt=""
                        />
                      </td>
                      <td>{{ dp.name }}</td>
                      <td>
                        <input
                          type="number"
                          min="0"
                          :id="'inputPaketQty' + (index + 1)"
                          class="form-control"
                          placeholder="Masukan Jumlah Quantity"
                        />{{ dp.qty }}
                      </td>
                      <td>
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="
                            addPaket(
                              dp.product_id,
                              `#inputPaketQty${index + 1}`
                            )
                          "
                        >
                          Tambah
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- {{dataPaket}} -->
                <table
                  class="table table-condensed text-center table-hover"
                  width="100%"
                >
                  <thead>
                    <tr
                      class="
                        table-condensed
                        text-uppercase text-muted text-sm-center
                      "
                    >
                      <th>No</th>
                      <th>Cover</th>
                      <th>Name</th>
                      <th>Qty</th>
                      <th>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(pd, index) in paketData" :key="index">
                      <td>{{ index + 1 }}</td>
                      <th scope="row">
                        <img
                          :src="
                            'https://cdn.eurekabookhouse.co.id/ebh/product/all/' +
                              pd.image
                          "
                          class="img-responsive"
                          height="50px"
                          alt=""
                        />
                      </th>
                      <td>
                        {{ pd.name }}<br />
                        {{ formatRupiah(pd.price) }}
                      </td>
                      <td>{{ pd.quantity }}</td>
                      <td>
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="deletePaket(pd.packet_did)"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- {{paketData}} -->

        <div class="card-header">
          <h5 class="mb-2">
            <b>Harga Grosir</b>
          </h5>
          <p class="grosir-info">
            Masukkan harga grosir. Harga grosir biasanya lebih murah daripada
            harga satuan. Harga grosir memiliki minimum pembelian dan harga
            bertingkat (3-4 tingkat). Barang seperti ini disebut juga barang
            Wholesale.
          </p>
        </div>
        <div class="card-body" id="grosirCollapse" style="">
          <div class="row">
            <div class="col-12">
              <!-- harga grosir mapping -->
              <div
                class="form-row mb-4 mb-4"
                v-for="(fakeForEach, index) in 4"
                :key="index"
              >
                <div class="col-md-2">
                  <div class="form-group">
                    <div class="form-group">
                      <label>Pembelian Minimum</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <label class="input-group-text">Min.</label>
                        </div>
                        <input
                          min="0"
                          max="999999999999"
                          maxlength="20"
                          onkeyup="this.value=this.value.slice(0,this.maxLength||1/1);
                              this.value=(this.value   < 0) ? (1/1) : this.value;"
                          class="form-control"
                          type="number"
                          :name="'nonBookMinWholesale' + (index + 1)"
                          :id="'nonBookMinWholesale' + (index + 1)"
                          v-model="minGrosir[index]"
                          @keyup="
                            validateNotNull('nonBookMinWholesale' + (index + 1))
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md">
                  <div class="form-group">
                    <label class="text-success">@Harga Grosir</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <label class="input-group-text">Rp.</label>
                      </div>
                      <CurrencyInput
                        max="999999999999"
                        maxlength="20"
                        v-model="hargaGrosir[index]"
                        :name="'nonBookWholesalePrice' + (index + 1)"
                        :id="'nonBookWholesalePrice' + (index + 1)"
                        :disabled="minGrosir[index] <= 0"
                        @keyup="
                          validateNotNull('nonBookWholesalePrice' + (index + 1))
                        "
                        class="form-control"
                      />
                      <div
                        v-if="minGrosir[index] <= 0"
                        class="invalid-feedback"
                      >
                        Masukan jumlah pembelian minimum terlebih dahulu
                      </div>
                      <!-- ppn grosir -->
                      <table v-if="isPpnDikenakan">
                        <tr>
                          <td width="20%"><small>DPP PPH</small></td>
                          <td width="2%">:</td>
                          <td>
                            <span :id="'dppGrosir' + (index + 1)">
                              {{ formatCurrency(dppGrosir[index]) }}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td width="20%"><small>DPP Nilai Lain</small></td>
                          <td width="2%">:</td>
                          <td>
                            <span :id="'dppNilaiLainGrosir' + (index + 1)">
                              {{ formatCurrency(dppNilaiLainGrosir[index]) }}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><small>PPN 12%</small></td>
                          <td>:</td>
                          <td>
                            <span :id="'ppnGrosir' + (index + 1)">
                              {{ formatCurrency(ppnGrosir[index]) }}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><small>PPh 0.5%</small></td>
                          <td>:</td>
                          <td>
                            <span :id="'pphGrosir' + (index + 1)">
                              {{ formatCurrency(pphGrosir[index]) }}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><small>Dana diterima oleh penyedia</small></td>
                          <td>:</td>
                          <td>
                            <span :id="'danaDiterimaGrosir' + (index + 1)">
                              {{ formatCurrency(danaDiterimaGrosir[index]) }}
                            </span>
                          </td>
                        </tr>
                      </table>

                      <!-- no ppn grosir -->
                      <table v-if="!isPpnDikenakan">
                        <tr>
                          <td width="20%"><small>DPP PPH</small></td>
                          <td width="2%">:</td>
                          <td>
                            <span :id="'dppGrosir' + (index + 1)">
                              {{ formatCurrency(hargaGrosir[index]) }}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td width="20%"><small>DPP Nilai Lain</small></td>
                          <td width="2%">:</td>
                          <td>
                            <span :id="'dppNilaiLainGrosir' + (index + 1)">
                              {{ formatCurrency(0) }}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><small>PPN 12%</small></td>
                          <td>:</td>
                          <td>
                            {{ formatCurrency(0) }}
                          </td>
                        </tr>
                        <tr>
                          <td><small>PPh 0.5%</small></td>
                          <td>:</td>
                          <td>
                            <span :id="'pphGrosir' + (index + 1)">
                              {{ formatCurrency(hargaGrosir[index] * 0.005) }}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><small>Dana diterima oleh penyedia</small></td>
                          <td>:</td>
                          <td>
                            <span :id="'danaDiterimaGrosir' + (index + 1)">
                              {{
                                formatCurrency(
                                  hargaGrosir[index] -
                                    hargaGrosir[index] * 0.005
                                )
                              }}
                            </span>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <small
                      >*Perhitungan ini adalah simulasi. Besaran dana disalurkan
                      dapat berkurang apabila terdapat pemotongan biaya
                      administrasi layanan dari mitra</small
                    >
                    <Br />
                    <small
                      >*PPN yang dikenakan telah menggunakan perhitungan terbaru
                      sesuai dengan PMK No. 131 Tahun 2024</small
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import $ from "jquery";
import { mapGetters } from "vuex";

export default {
  props: {
    renderComponent: Boolean,
    isChecked: Boolean,
    ppnValue: Number,
    findPaket: String,
    findProductPacket: Function,
    addProductid: Function,
    addPaket: Function,
    dataPaket: Array,
    getPaketData: Function,
    deletePaket: Function,
    paketData: Array,
  },

  data() {
    return {
      nonBookUnitPrice: "", // Harga Satuan Non-Buku
      nonBookMaxNegoPrice: "",
      hargaSatuan: 0,
      maksNego: 0,
      minGrosir: [0, 0, 0, 0],
      hargaGrosir: [0, 0, 0, 0],
      tagValue: null,
    };
  },
  mounted() {
    this.tagValue = $("#tagPpnNonbok")
      .val()
      ?.trim();

    this.updateTagValue();
    $(document).on("change", "#tagPpnNonbok", this.updateTagValue);
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn",
      user: "user",
    }),

    dpp() {
      return this.floorExcelLike(this.nonBookUnitPrice / 1.11);
    },
    dppNilaiLain() {
      return this.floorExcelLike((11 / 12) * (this.nonBookUnitPrice / 1.11));
    },
    ppn() {
      return Math.ceil((this.nonBookUnitPrice / 1.11) * (11 / 12) * 0.12);
    },
    pph() {
      return this.floorExcelLike((this.nonBookUnitPrice / 1.11) * 0.005);
    },

    // dpp() {
    //   console.log($("#dppNilaiLainHargaSatuan").val(), "jquery");
    //   return Math.round(this.nonBookUnitPrice / 1.11);
    // },

    // dppNilaiLain() {
    //   // FLOOR((E21 / 1.11) * (11 / 12))
    //   return Math.floor((this.nonBookUnitPrice / 1.11) * (11 / 12));
    // },

    // ppn() {
    //   return Math.ceil((this.nonBookUnitPrice / 1.11) * (11 / 12) * 0.12);
    // },

    // pph() {
    //   return Math.floor(this.dpp * 0.005);
    // },
    pphNoPpn() {
      return Math.floor(this.nonBookUnitPrice * 0.005);
    },
    danaDiterima() {
      return this.nonBookUnitPrice - this.ppn - this.pph;
    },
    // Nego
    dppNego() {
      console.log(this.tagValue);
      return this.floorExcelLike(this.nonBookMaxNegoPrice / 1.11);
    },
    dppNilaiLainNego() {
      return this.floorExcelLike((11 / 12) * (this.nonBookMaxNegoPrice / 1.11));
    },
    ppnNego() {
      return Math.ceil((this.nonBookMaxNegoPrice / 1.11) * (11 / 12) * 0.12);
    },
    pphNego() {
      return Math.floor(this.dppNego * 0.005);
    },
    pphNegoNoPpn() {
      return Math.floor(this.nonBookMaxNegoPrice * 0.005);
    },
    danaDiterimaNego() {
      return this.nonBookMaxNegoPrice - this.ppnNego - this.pphNego;
    },
    // grosir
    dppGrosir() {
      return this.hargaGrosir.map((pg, index) => {
        const price = Number(pg) || 0;
        if (Number(this.minGrosir[index]) === 0) {
          return 0;
        }
        const dppPerUnit = this.floorExcelLike(price / 1.11); // rumus sudah benar
        return dppPerUnit;
      });
    },
    dppNilaiLainGrosir() {
      return this.hargaGrosir.map((pg, index) => {
        const price = Number(pg) || 0;

        if (price === 0) return 0;

        if (Number(this.minGrosir[index]) === 0) {
          return 0;
        }

        const dppPerUnit = (11 / 12) * (price / 1.11); // Jangan dibulatkan dulu
        return this.floorExcelLike(dppPerUnit); // Bulatkan hasil akhir
      });
    },

    ppnGrosir() {
      return this.hargaGrosir.map((pg, index) => {
        const price = Number(pg) || 0;

        if (price === 0) return 0;

        if (Number(this.minGrosir[index]) === 0) {
          return 0;
        }

        const ppnPerUnit = (price / 1.11) * (11 / 12) * 0.12;
        return Math.ceil(ppnPerUnit);
      });
    },
    pphGrosir() {
      return this.hargaGrosir.map((pg, index) => {
        return Math.floor(this.dppGrosir[index] * 0.005);
      });
    },
    danaDiterimaGrosir() {
      return this.hargaGrosir.map((pg, index) => {
        const price = Number(pg) || 0;
        if (Number(this.minGrosir[index]) === 0) {
          return 0;
        }
        const nettoPerUnit =
          price - this.ppnGrosir[index] - this.pphGrosir[index];
        return nettoPerUnit;
      });
    },

    isPpnDikenakan() {
      if (!this.tagValue) return false;

      const firstPart = this.tagValue.split(":")[0];
      return String(firstPart) === "0";
    },
    danaDiterimaNoPpn() {
      return this.nonBookUnitPrice - this.pphNoPpn;
    },
    danaDiterimaNoPpnNego() {
      return this.nonBookMaxNegoPrice - this.pphNegoNoPpn;
    },
    danaDiterimaNoPpnGrosir() {
      return this.hargaGrosir.map((pg) => {
        const price = Number(pg) || 0;
        return this.nonBookUnitPrice - price * 0.005;
      });
    },
  },
  watch: {
    minGrosir: {
      handler(newVal) {
        newVal.forEach((val, index) => {
          if (val < 0) {
            this.minGrosir.splice(index, 1, 0); // hanya nol-kan kalau negatif
          }
          // tidak mengubah hargaGrosir
        });
      },
      deep: true,
      immediate: false,
    },
    hargaSatuan() {
      if (this.hargaSatuan === null) {
        $(".invalidHargaSatuan").text(`Harga tidak boleh kosong`);
        $("#nonBookUnitPrice").addClass("is-invalid");
      } else {
        $("#nonBookUnitPrice").removeClass("is-invalid");
      }
    },
    maksNego() {
      if (this.maksNego === null) {
        $(".invalidMaksNego").text(`Harga tidak boleh kosong`);
        $("#nonBookMaxNegoPrice").addClass("is-invalid");
      } else {
        $("#nonBookMaxNegoPrice").removeClass("is-invalid");
      }
    },
  },
  methods: {
    roundIEEE(value, decimals = 2) {
      const factor = Math.pow(10, decimals);
      return Math.round((value + Number.EPSILON) * factor) / factor;
    },

    floorIEEE(value, decimals = 2) {
      const factor = Math.pow(10, decimals);
      return Math.floor((value + Number.EPSILON) * factor) / factor;
    },

    ceilIEEE(value, decimals = 2) {
      const factor = Math.pow(10, decimals);
      return Math.ceil((value - Number.EPSILON) * factor) / factor;
    },

    floorPpnExcelLike(number, precision = 0.1) {
      const factor = 1 / precision;
      return parseFloat(
        (Math.ceil(number * factor - 1e-6) / factor).toFixed(1)
      );
    },

    floorExcelLike(number) {
      const sen = Math.floor(number * 100);
      return Math.floor(sen / 100);
    },

    updateTagValue() {
      this.tagValue = $("#tagPpnNonbok")
        .val()
        ?.trim();
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(value);
    },
    validateNotNull(idEl) {
      let element = $(`#${idEl}`);

      // if (element.val().includes("-")) {
      //   $(`#${idEl}`).val(0);
      // }

      if (element.val() === "") {
        element.addClass("is-invalid");
      } else if (element.val().includes("-")) {
        element.val(0);
        element.removeClass("is-invalid");
      } else {
        element.removeClass("is-invalid");
      }
    },
    formatRupiah(angka) {
      var number_string = angka.replace(/[^,\d]/g, "").toString(),
        split = number_string.split(","),
        sisa = split[0].length % 3,
        rupiah = split[0].substr(0, sisa),
        ribuan = split[0].substr(sisa).match(/\d{3}/gi);

      // tambahkan titik jika yang di input sudah menjadi angka ribuan
      if (ribuan) {
        var separator = sisa ? "." : "";
        rupiah += separator + ribuan.join(".");
      }

      rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
      return "Rp " + rupiah;
    },
  },
};
</script>
